export default __webpack_public_path__ + "cc160e99ea74af5037f5f3097c5734d1.png";